import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'payTranslateMany',
    standalone: false
})
export class TranslateManyPipe implements PipeTransform {

    constructor(private translateService: TranslateService) {
    }

    transform(value: string, count?: number, translateParams?: any): string {
        if (!value) {
            return '';
        }
        if(count && count > 1 && !value.endsWith('Many')) {
            value = `${value}.Many`;
        }
        return this.translateService.instant(value, translateParams);
    }
}
